import { Injectable } from '@angular/core';
import { ContentType } from '@compumark/analyst-selection-tool-client';

@Injectable()
export class PreferenceStorageService {
  localStorage: Storage | null;

  constructor() {
    this.localStorage = window.localStorage;
  }

  getPreference(key: string): any | undefined {
    if (!!this.localStorage) {
      const item = this.localStorage.getItem(key);
      if (!!item) {
        return JSON.parse(item);
      }
    }
    return undefined;
  }

  setPreference(key: string, value: any): boolean {
    if (!!this.localStorage) {
      this.localStorage.setItem(key, JSON.stringify(value));
      return true;
    }
    return false;
  }
  deletePreference(key: string): void {
    localStorage.removeItem(key);
  }
  getFilterModelKeys(resultDeliveryId: string): string[] {
    const contentTypes = [
      ContentType.TRADEMARK,
      ContentType.PHARMA,
      ContentType.COMMON_LAW,
      ContentType.DOMAIN_NAMES,
      ContentType.COMPANY_NAMES,
    ];
    return contentTypes.map((type) => `filterModel${type}${resultDeliveryId}`);
  }
  deleteAppliedFilter(key: string, property: string): void {
    const item = localStorage.getItem(key);
    if (item) {
      const obj = JSON.parse(item);
      delete obj[property];
      localStorage.setItem(key, JSON.stringify(obj));
    }
  }
}
